import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralStepperComponent } from './general-stepper.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [GeneralStepperComponent],
  imports: [CommonModule, MatProgressBarModule, MatStepperModule],
})
export class GeneralStepperModule {}
